'use strict';

import { getVueTemplate } from '../../../_imports/utils/utils.common';
import ResourceCardCommon from './_imports/shared/resource-card.common';
import ResourceCardList from './resource-card-list/resource-card-list.vue';
import ResourceCardMedium from './resource-card-medium/resource-card-medium.vue';
import ResourceCardHorizontalTopPicks from './resource-card-horizontal-top-picks/resource-card-horizontal-top-picks.vue';
import ResourceCardThumbnail from './resource-card-thumbnail/resource-card-thumbnail.vue';

export default {
    template: getVueTemplate('resource-card'),
    mixins: [ResourceCardCommon],
    components: {
        ResourceCardList,
        ResourceCardHorizontalTopPicks,
        ResourceCardThumbnail,
        ResourceCardMedium,
    },
    props: {
        styling: Object,
        resource: Object,
        linkType: String,
        popUpBehaviourActivated: Boolean,
        overrideCardWidth: [String, null]
    },
    methods: {
        openPopUpModal(resourceId){
            this.$emit('openPopUpModal', resourceId);
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.$el.classList) {
                this.$el.classList.add("component-is-mounted");
            }
        }, 150);
    },
};